<template>
    <div>
        <v-dialog v-model="pollDialog" v-if="active_poll && has_not_voted">
            <template v-slot:activator="{on}">
                <v-btn
                        fab
                        v-on="on"
                        fixed
                        bottom
                        left
                        :style="`bottom: ${($vuetify.breakpoint.smAndDown ? 72 : 16) + chatOffset}px`"
                        color="primary"
                        :class="dark ? 'white--text' : 'black--text'"
                >
                    <v-icon>mdi-poll</v-icon>
                </v-btn>
            </template>
            <v-card color="primary" :dark="dark">
                <v-card-title class="text-break">
                    <v-row>
                        <v-col cols="auto" v-if="$vuetify.breakpoint.smOnly">
                            <v-icon left>mdi-poll</v-icon>
                        </v-col>
                        <v-col>
                            <span :class="$vuetify.breakpoint.smOnly ? 'text-h5' : 'text-subtitle-1'">{{active_poll.question}}</span>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn icon @click="pollDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6" v-for="(answer, idx) in active_poll.answers"
                               @click="vote(answer.id)" :key="idx">
                            <v-btn block :color="dark ? 'white' : 'black'" style="text-transform: none" outlined :large="$vuetify.breakpoint.smOnly">
                                {{ answer.answer }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import gql from "graphql-tag";


    export default {
        name: 'PollDialog',
        data: () => ( {
            pollDialog: false,
            voted: [],
        } ),
        mounted ()
        {
            this.pollDialog = !!this.active_poll;
        },
        watch: {
            active_poll ()
            {
                this.pollDialog = !!this.active_poll;
            },
        },
        computed: {
            ...mapState( ['event', 'room', 'chatOffset'] ),
            ...mapGetters( ['dark'] ),
            active_poll ()
            {
                let room = this.room;
                if ( room && room.pollSetting && room.pollSetting.active_poll )
                {
                    return room.pollSetting.active_poll;
                }
                return null;
            },
            has_not_voted ()
            {
                return this._.findIndex( this.voted, ( poll_id ) =>
                {
                    return `${ poll_id }` === `${ this.active_poll.id }`;
                } ) === -1;
            },
        },
        methods: {
            vote ( id )
            {
                // Result
                this.voted.push( this.active_poll.id );
                this.$apollo.mutate( {
                    // Query
                    mutation: gql`mutation ($id: ID!) {
                                submitAnswer(id: $id)
                              }`,
                    variables: {
                        id: id,
                    },
                } );
            },
        },
    };
</script>

<style scoped>
</style>